/**
 * Allows exploded query parameters to be appended rather than replaced.
 * Will be fixed in a future release of the generator.
 * https://github.com/OpenAPITools/openapi-generator/pull/8772
 */
export const setSearchParams = function (url: URL, ...objects: any[]) {
    const searchParams = new URLSearchParams(url.search);
    for (const object of objects) {
        for (const key in object) {
            if (Array.isArray(object[key])) {
                searchParams.delete(key);
                for (const item of object[key]) {
                    searchParams.append(key, item);
                }
            } else {
                searchParams.set(key, object[key]);
            }

        }
    }
    url.search = searchParams.toString();
}
